goog.provide('el8.appshared.dialog.approveControlledMedPrintOnly');

goog.require('el8.uiwidget.QuickSelectDialog');
goog.require('el8.ptdata.rxRefillRequests');
goog.require('el8.ptdata.medOrders');


el8.appshared.dialog.approveControlledMedPrintOnly = (function() {

    var spec = null;

    var that = new el8.uiwidget.QuickSelectDialog({
        title: 'Refilling a Schedule II Controlled Substance',
        msg: 'This is a Schedule II Controlled substance, which can only be filled if the patient presents the script to the pharmacy on tamper-proof paper.',
        callbackFn: function(index) {
            var lookup = [
                function() {
                    el8.ptdata.rxRefillRequests.submitApproval(
                        spec.refill, spec.authRefills, spec.note, spec.noChange,
                        function(newOrder) {
                            el8.ptdata.medOrders.printSingle(newOrder, 'controlled');
                            that.hide();
                        }
                    );
                },
                function() { that.hide(); }
            ];
            return lookup[index] ? lookup[index]() : null;
        },
        list: [
            'Print script on tamper-proof prescription paper to be given to patient',
            'Cancel'
        ]
    });

    var super_show = that.show;
    that.show = function(_spec) {
        spec = _spec;
        super_show.call(that);
    };

    return that;

})();


